module.exports = __webpack_public_path__ + "img/access_account.c577cde4.svg";